exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-5fe0d5ea]{font-family:Montserrat}.title[data-v-5fe0d5ea]{text-align:center;font-weight:700;color:#ed1763}.btn-tagsell[data-v-5fe0d5ea]{background-color:#ed1763;color:#fff}@media screen and (max-width:768px){.btn-tagsell[data-v-5fe0d5ea]{display:block;width:100%}}p[data-v-5fe0d5ea]{color:#7b7b7b;font-size:1.2em;margin-top:15px;width:100%;text-align:center;font-weight:700}.d-flex[data-v-5fe0d5ea]{display:flex}.justify-center[data-v-5fe0d5ea]{justify-content:center}.activate-button-div[data-v-5fe0d5ea]{margin:20px 0}.success-message[data-v-5fe0d5ea]{display:flex;justify-content:center;align-items:center;font-size:1.2em;margin-top:15px;color:#7accbe!important}.store-tutorial[data-v-5fe0d5ea]{font-size:1em}.mb-50[data-v-5fe0d5ea]{margin-bottom:50px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fe0d5ea","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/PosterLimitContent.vue
// module id = mCFg
// module chunks = 101